<div class="min-h-screen bg-gradient-to-br from-[#2c5f8d] to-[#4A90E2] flex items-center justify-center p-4">
  <div class="w-full max-w-md">
    <!-- Logo -->
    <div class="text-center mb-8">
      <img src="https://zoomeduca.com.br/logo.svg" alt="Zoom Educa"
        class="w-32 mb-3 h-auto mx-auto brightness-0 invert drop-shadow-lg" />
      <h1 class="text-3xl font-bold text-white mb-2">
        {{ mode === 'login2FA' ? 'Autenticação de Dois Fatores' : 'Verificar Código' }}
      </h1>
      <p class="text-white/90">
        <span *ngIf="mode === 'login2FA'">Código de autenticação enviado para </span>
        <span *ngIf="mode !== 'login2FA'">Digite o código enviado para</span>
        <strong>{{ email }}</strong>
      </p>
    </div>

    <!-- Card -->
    <div class="bg-white rounded-lg shadow-xl p-8">
      <form (ngSubmit)="onSubmit()" #verifyForm="ngForm">
        <div class="space-y-6">
          <!-- Code -->
          <div>
            <label class="block text-sm font-medium text-gray-900 mb-4 text-center">
              {{ mode === 'login2FA' ? 'Código de Autenticação' : 'Código de Verificação' }}
            </label>
            <div class="flex justify-center gap-2 sm:gap-3">
              <input *ngFor="let digit of digits; let i = index; trackBy: trackByIndex" [id]="'code-input-' + i"
                type="text" inputmode="numeric" pattern="[0-9]*" maxlength="1" autocomplete="one-time-code"
                [name]="'digit-' + i" [(ngModel)]="digits[i]" (input)="onDigitInput($event, i)"
                (keydown)="onKeyDown($event, i)" (paste)="onDigitPaste($event)" (focus)="onFocus($event)"
                class="w-12 h-14 sm:w-14 sm:h-16 text-center text-2xl font-bold border-2 rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#4A90E2] focus:border-[#4A90E2]"
                [class.border-gray-300]="!submitted || digits[i]" [class.border-red-500]="submitted && !digits[i]"
                [class.bg-gray-50]="!digits[i]" [class.bg-white]="digits[i]" />
            </div>
            <p *ngIf="submitted && code.length < 6" class="mt-3 text-sm text-red-600 text-center">
              Por favor, preencha todos os dígitos do código
            </p>
          </div>

          <div class="flex flex-col gap-3 items-center">
            <!-- Submit Button -->
            <button app-button type="submit" [loading]="isLoading" loadingText="Verificando...">
              {{ mode === 'login2FA' ? 'Validar Código' : 'Verificar Código' }}
            </button>

            <!-- Resend Code -->
            <button app-button type="button" (click)="resendCode()" variant="outline" [disabled]="isResending"
              [loading]="isResending" loadingText="Reenviando...">
              Não recebeu o código? Reenviar
            </button>
          </div>

          <!-- Adicionar container com informações "Verifique a caixa de spam do seu email"-->
          <div class="w-full bg-blue-50/80 border border-blue-100 rounded-xl p-3 text-left shadow-sm">
            <h3 class="flex items-center gap-2 font-bold text-blue-900 mb-4 text-xs uppercase tracking-wide">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              Não encontrou o código?
            </h3>
            <ul class="space-y-1 text-xs text-blue-800">
              <li class="flex items-start gap-3">
                <span class="mt-1.5 w-1.5 h-1.5 bg-blue-500 rounded-full flex-shrink-0"></span>
                <span>Verifique a caixa de spam do seu email</span>
              </li>
              <li class="flex items-start gap-3">
                <span class="mt-1.5 w-1.5 h-1.5 bg-blue-500 rounded-full flex-shrink-0"></span>
                <span>Se você não recebeu o código, clique no botão "Reenviar" para receber um novo código.</span>
              </li>
            </ul>
          </div>

          <!-- Back to Login -->
          <button app-button variant="ghost" [routerLink]="mode === 'login2FA' ? '/login' : '/login'"
            className="text-sm text-gray-600 hover:text-[#4A90E2] font-medium">
            Voltar para o login
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<app-toast></app-toast>